import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { GroupsApi } from 'api/groups';
import { ALL_MEMBERS_QUERY_KEY } from './members';
export const GroupsListQueryKey = [
    'user-groups'
];
export const useGroupsQuery = (queryOptions = {})=>{
    var _ref;
    return useQuery(GroupsListQueryKey, ()=>GroupsApi.getGroups(), {
        ...queryOptions,
        cacheTime: (_ref = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.cacheTime) !== null && _ref !== void 0 ? _ref : 0
    });
};
export const getGroupByUserQueryKeyUsingId = (userId)=>[
        'user-group',
        userId
    ];
export const useGroupsByUserQuery = (userId, options = {})=>useQuery(getGroupByUserQueryKeyUsingId(userId), ()=>GroupsApi.getGroupsByUser(userId), {
        ...options
    });
export const getGroupDetailQueryKeyUsingId = (groupId)=>[
        'user-group',
        groupId
    ];
export const useGroupDetailQuery = (groupId, options = {})=>useQuery(getGroupDetailQueryKeyUsingId(groupId), ()=>GroupsApi.getGroupDetail(groupId), {
        ...options,
        cacheTime: 0
    });
export const useCreateGroupMutation = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload)=>GroupsApi.createGroup(payload),
        onSuccess: ()=>{
            queryClient.refetchQueries([
                'user-group'
            ]);
            queryClient.refetchQueries(ALL_MEMBERS_QUERY_KEY);
        }
    });
};
export const useDeactivateGroupMutation = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (groupId)=>GroupsApi.deactivateGroup(groupId),
        onSuccess: ()=>{
            queryClient.refetchQueries([
                'user-group'
            ]);
            queryClient.refetchQueries(ALL_MEMBERS_QUERY_KEY);
        }
    });
};
export const useUpdateGroupMutation = ()=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload)=>GroupsApi.updateGroup(payload),
        onSuccess: ()=>{
            queryClient.refetchQueries([
                'user-group'
            ]);
            queryClient.refetchQueries(ALL_MEMBERS_QUERY_KEY);
        }
    });
};
export const useDeleteMembersInGroupMutation = (groupId)=>{
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload)=>GroupsApi.deleteMemberInGroup(payload),
        onSuccess: ()=>Promise.all([
                queryClient.invalidateQueries([
                    'user-group',
                    groupId
                ]),
                queryClient.invalidateQueries([
                    'user-groups'
                ])
            ])
    });
};
